function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13739_233)",
  fill: "#000",
  fillOpacity: ".65"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.893 3.561c.152-.325-.457-.213 0 0l11.07 5.162c.457.213.152-.325 0 0l-1.222 2.622 2.621 1.223 1.359-2.914a2.574 2.574 0 00-1.244-3.417L18.825.804a2.574 2.574 0 00-3.418 1.243L14.05 4.96l2.622 1.223 1.222-2.622zm17.13 11.18L9.388 2.787a1.284 1.284 0 00-1.709.622l-.543 1.165a.322.322 0 00.155.427l27.384 12.77c.16.074.352.004.427-.156l.543-1.165c.3-.645.023-1.408-.622-1.709zM5.319 17l.992 14.617a2.574 2.574 0 002.568 2.45h18.24a2.568 2.568 0 002.568-2.45L30.68 17H5.319zm21.492 14.175H9.188L8.216 17h19.567l-.973 14.175z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.34 14.272c-2.465-3.24-6.132-4.943-9.842-4.962l-.006-2.06c0-.209-.238-.325-.395-.196l-4.004 3.25a.258.258 0 000 .396L5.1 13.953c.16.13.397.013.394-.196v-2.056a10.006 10.006 0 014.937 1.326c1.192.682 2.227 1.599 3.078 2.712a10.599 10.599 0 011.818 3.727h2.388a13.036 13.036 0 00-2.375-5.194z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13739_233"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h36v36H0z"
}))));